import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

interface FrameRenderDetail {
  render: (currentFrame: Element, newFrame: Element) => void
}

interface MorphAttributeDetail {
  attributeName: string
}

// I-UX-S2-06 live list filters, on a list's frame (top-level list_frame, hub section frames):
// - the new content is morphed into the frame, not swapped, so the search box keeps focus, caret and what was typed
//   while the request ran (ignoreActiveValue), and open dropdowns („Další filtry“, a select's options) stay open;
// - a frame advancing history (top-level list) first pins the current entry to the explicit URL of the filter it
//   shows (urlValue), once: the page's own URL may rely on the stored filter (Q-480), which Back would bring back as
//   the newest one instead of the earlier.
export default class LiveListController extends Controller<HTMLElement> {
  static override values = { url: String }
  declare readonly urlValue: string
  declare readonly hasUrlValue: boolean
  private pinned = false

  morph(event: Event): void {
    if (event.target !== this.element || !(event instanceof CustomEvent)) return

    // I-WALK-05: only a focused form control keeps what was typed. idiomorph skips the children of any focused node,
    // so a just-clicked link (Konec úprav, a sort header) would keep its old text next to the new list.
    const active = document.activeElement
    const typing = active instanceof HTMLInputElement || active instanceof HTMLTextAreaElement || active instanceof HTMLSelectElement
    const detail = event.detail as FrameRenderDetail
    detail.render = (currentFrame, newFrame) => Turbo.morphChildren(currentFrame, newFrame, { ignoreActiveValue: typing })
  }

  keepOpen(event: Event): void {
    if (!(event instanceof CustomEvent) || !(event.target instanceof HTMLDetailsElement)) return
    if ((event.detail as MorphAttributeDetail).attributeName === 'open') event.preventDefault()
  }

  pin(): void {
    if (this.pinned || !this.hasUrlValue || this.urlValue === '') return

    this.pinned = true
    window.history.replaceState(window.history.state, '', this.urlValue)
  }
}
